import { Injectable } from '@angular/core';
import { act, Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map, mergeMap, concatMap, tap } from 'rxjs/operators';
import { ToastService } from 'src/app/shared/services/toast.service';
import { LobbyEntryService } from '../../shared/services/lobby-entry.service';
import * as LobbyWrapUpPageActions from './actions/wrap-up-page.actions';
import * as LobbyWrapUpApiActions from './actions/lobby-wrap-up-api.actions';
import { LobbyService } from '../../shared/services/lobby.service';
import { LobbyEntryImpersonateDto } from '../../shared/models/lobby-entry-impersonate.dto';

@Injectable()
export class LobbyWrapUpEffects {

    constructor(private actions$: Actions,
                private lobbyEntryService: LobbyEntryService,
                private lobbyService: LobbyService,
                private toastService: ToastService) { }

    loadLobbyDetails$ = createEffect(() => {
        return this.actions$
            .pipe(
                ofType(LobbyWrapUpPageActions.assistLobbyEntry),
                concatMap(action => {
                    if (!action.isInstantAssist) {
                        return this.lobbyEntryService.assist(action.lobbyEntryId, action.assistingUserId, action.locationId)
                                .pipe(
                                    concatMap(assistedLobbyEntry => {
                                        return this.lobbyEntryService.getLobbyEntryDetails(assistedLobbyEntry)
                                                .pipe(
                                                    map(lobbyEntry => LobbyWrapUpApiActions.assistLobbyEntrySuccess({
                                                        lobbyEntryDetail: lobbyEntry,
                                                        showLobbyCategory: action.showLobbyCategory,
                                                        isImpersonateAssist: action.isImpersonateAssist,
                                                        impersonateByName: action.impersonateByName
                                                    })),
                                                    catchError(error => {
                                                        console.log('Error retrieving lobby entry detail');
                                                        return of(LobbyWrapUpApiActions.assistLobbyEntryFailure({ error }));
                                                    })
                                                );
                                    }),
                                    catchError(error => {
                                        console.log('Assist failed!');
                                        this.toastService.showError(error);
                                        return of(LobbyWrapUpApiActions.assistLobbyEntryFailure({ error }));
                                    })
                                );
                    } else {
						return this.lobbyEntryService.getLobbyEntryDetails(action.lobbyEntryId).pipe(
						  map(lobbyEntry => {
							if (lobbyEntry.status === 2) {
							  return LobbyWrapUpApiActions.assistLobbyEntrySuccess({
								  lobbyEntryDetail: lobbyEntry,
								  showLobbyCategory: action.showLobbyCategory,
								  isImpersonateAssist: action.isImpersonateAssist,
								  impersonateByName: action.impersonateByName,
								});
							}
							// Treat invalid status as business-logic failure
							return LobbyWrapUpApiActions.assistLobbyEntryFailure({
								error: 'Cannot assist lobby entry: invalid status ${lobbyEntry.status} (expected Assisting)'
							  });
						  }),
						  catchError(error => {
							console.error('Error retrieving lobby entry details:', error);
							return of(
							  LobbyWrapUpApiActions.assistLobbyEntryFailure({ error })
							);
						  })
						);
                    }
                })
            );
        });
    openWraupUpLobbyDetails$ = createEffect(() => {
        return this.actions$
            .pipe(
                ofType(LobbyWrapUpPageActions.loadWrapUpPopUp),
                concatMap(action => {                  
                return this.lobbyEntryService.getLobbyEntryDetails(action.lobbyEntryId)
                    .pipe(
                        map(lobbyEntry => LobbyWrapUpApiActions.impersonateAssistLobbyEntrySuccess({
                            lobbyEntryDetail: lobbyEntry,
                            showLobbyCategory: action.showLobbyCateogory,
                            isImpersonateAssist: action.isImpersonateAssist,
                            impersonateByName: action.impersonatedByName,
                            impersonatedByCode: action.impersonatedByCode 
                        })),
                        catchError(error => {
                            console.log('Error retrieving lobby entry detail');
                            return of(LobbyWrapUpApiActions.impersonateAssistLobbyEntryFailure({ error }));
                        })
                    );
            })
        );
    });
                               


    loadImpersonateLobbyDetails$ = createEffect(() => {
        return this.actions$
            .pipe(
                ofType(LobbyWrapUpPageActions.impersonateAssistLobbyEntry),
                concatMap(action => {
                  
                        return this.lobbyEntryService.impersonateAssist(action.payload)
                                .pipe(
                                    concatMap(assistedLobbyEntry => {
                                        console.log(assistedLobbyEntry);
                                        //return null;
                                        return this.lobbyEntryService.getLobbyEntryDetails(assistedLobbyEntry)
                                                .pipe(
                                                    map(lobbyEntry => LobbyWrapUpApiActions.impersonateAssistLobbyEntrySuccess({
                                                        lobbyEntryDetail: lobbyEntry,
                                                        showLobbyCategory: action.payload.ShowLobbyCategory,
                                                        isImpersonateAssist: true,
                                                        impersonateByName: action.payload.impersonatedByName,
                                                        impersonatedByCode: action.payload.impersonatedByCode
                                                    })),
                                                    catchError(error => {
                                                        console.log('Error retrieving lobby entry detail');
                                                        return of(LobbyWrapUpApiActions.impersonateAssistLobbyEntryFailure({ error }));
                                                    })
                                                );
                                    }),
                                    catchError(error => {
                                        console.log(error);
                                        console.log('Impersonate Assist failed!');
                                        if(error.includes("object")){
                                            this.toastService.showError('_Lobby_WrapUP_Impersonate_Assist_Fail_Text_');
                                        }
                                        else{
                                            this.toastService.showError(error);
                                        }  
                                       
                                        return of(LobbyWrapUpApiActions.impersonateAssistLobbyEntryFailure({ error }));
                                    })
                                );
                    
                })
            );
    });
    

    loadLobbyServices$ = createEffect(() => {
        return this.actions$
        .pipe(
            ofType(LobbyWrapUpApiActions.assistLobbyEntrySuccess),
            mergeMap(action => this.lobbyService.getServices(action.lobbyEntryDetail.locationId,true,action.showLobbyCategory)
                .pipe(
                    map(services => LobbyWrapUpApiActions.loadServicesSuccess({ services })),
                    catchError(error => of(LobbyWrapUpApiActions.loadServicesFailure({ error })))
                )
            )
        );
    });   
    loadImpersonateLobbyServices$ = createEffect(() => {
        return this.actions$
        .pipe(
            ofType(LobbyWrapUpApiActions.impersonateAssistLobbyEntrySuccess),
            mergeMap(action => this.lobbyService.getServices(action.lobbyEntryDetail.locationId,true,action.showLobbyCategory)
                .pipe(
                    map(services => LobbyWrapUpApiActions.loadServicesSuccess({ services })),
                    catchError(error => of(LobbyWrapUpApiActions.loadServicesFailure({ error })))
                )
            )
        );
    });
    

    returnVisitorToLobby$ = createEffect(() => {
        return this.actions$
        .pipe(
            ofType(LobbyWrapUpPageActions.backToLobby),
            mergeMap(action => this.lobbyEntryService.backToLobby({signedInLocationId:action.assistingUserLocationId,comment:action.comment,lobbyEntryId:action.lobbyEntryId})
                .pipe(
                    map(services => LobbyWrapUpApiActions.backToLobbySuccess({ services:services,isImpersonateAssist:action.isImpersonateAssist })),
                    catchError(error => {
                        console.log('Error returning visitor to lobby');
                        return of(LobbyWrapUpApiActions.backToLobbyFailure({ error }));
                    })
                )
            )
        );
    });

    provideService$ = createEffect(() => {
        return this.actions$
        .pipe(
            ofType(LobbyWrapUpPageActions.provideService),
            mergeMap(action => this.lobbyEntryService.provideService(action.lobbyEntryId, action.serviceId)
                .pipe(                   
                    map(providedServices => {
                        providedServices.forEach(c => c.showEditReference = false);
                        return LobbyWrapUpApiActions.provideServiceSuccess({providedServices});
                    }),
                    catchError(error => {
                        console.log('Error providing service');
                        return of(LobbyWrapUpApiActions.provideServiceFailure({ error }));
                    })
                )
            )
        );
    });

    updateProvideServiceReference$ = createEffect(() => {
        return this.actions$
        .pipe(
            ofType(LobbyWrapUpPageActions.updateProvidedServiceReference),
            mergeMap(action => this.lobbyEntryService.updateProvidedServiceReference(action.lobbyEntryId, action.serviceProvidedId, action.reference)
                .pipe(
                    map(providedServices => {
                        providedServices.forEach(c => c.showEditReference = false);
                        return LobbyWrapUpApiActions.updateProvideServiceReferenceSuccess({providedServices});
                    }),
                    catchError(error => {
                        console.log('Error updating service reference');
                        return of(LobbyWrapUpApiActions.updateProvideServiceReferenceFailure({ error }));
                    })
                )
            )
        );
    });

    removeProvideService$ = createEffect(() => {
        return this.actions$
        .pipe(
            ofType(LobbyWrapUpPageActions.removeProvidedService),
            mergeMap(action => this.lobbyEntryService.removeProvidedService(action.lobbyEntryId, action.serviceProvidedId)
                .pipe(
                    map(providedServices => {
                        providedServices.forEach(c => c.showEditReference = false);
                        return LobbyWrapUpApiActions.removeProvideServiceSuccess({providedServices});
                    }),
                    catchError(error => {
                        console.log('Error removing service');
                        return of(LobbyWrapUpApiActions.removeProvideServiceFailure({ error }));
                    })
                )
            )
        );
    });

    getCheckListForService$ = createEffect(() => {
        return this.actions$
        .pipe(
            ofType(LobbyWrapUpPageActions.getCheckList),
            mergeMap(action => this.lobbyService.getCheckList(action.serviceId)
                .pipe(
                    map(checkList => {
                        checkList.forEach(c => c.checked = false);
                        return LobbyWrapUpApiActions.getCheckListForServiceeSuccess({checkList});
                    }),
                    catchError(error => {
                        console.log('Error retrieving check list');
                        return of(LobbyWrapUpApiActions.getCheckListForServiceFailure({ error }));
                    })
                )
            )
        );
    });

    getCheckListForRequestedService$ = createEffect(() => {
        return this.actions$
        .pipe(
            ofType(LobbyWrapUpPageActions.getCheckListForRequestedService),
            mergeMap(action => this.lobbyService.getCheckListForMultipleServices(action.serviceIds)
                .pipe(
                    map(checkList => {
                        return LobbyWrapUpApiActions.getCheckListForRequestedServiceeSuccess({checkList});
                    }),
                    catchError(error => {
                        console.log('Error retrieving check list');
                        return of(LobbyWrapUpApiActions.getCheckListForServiceFailure({ error }));
                    })
                )
            )
        );
    });

    wrapUp$ = createEffect(() => {
        return this.actions$
        .pipe(
            ofType(LobbyWrapUpPageActions.wrapUpAssist),
            mergeMap(action => this.lobbyEntryService.wrapUp(action.wrapUpData)
                .pipe(
                    map(() => {
                        this.toastService.showSuccess('_Lobby_WrapUP_Interaction_Success_Text_');
                        return LobbyWrapUpApiActions.wrapUpSuccess();
                    }),
                    catchError(error => {
                        this.toastService.showError('_Lobby_WrapUP_Interaction_Fail_Text_');
                        return of(LobbyWrapUpApiActions.wrapUpFailure({ error }));
                    })
                )
            )
        );
    });

    isVisitorArrived$ = createEffect(() => {
        return this.actions$
        .pipe(
            ofType(LobbyWrapUpPageActions.isVisitorArrived),
            mergeMap(action => this.lobbyEntryService.updateRemoteCheckInStatus(action.lobbyEntryId,action.isArrived)
                .pipe(
                    map(() => {
                        this.toastService.showSuccess('_Lobby_WrapUP_Visitor_Status_Update_Success_Text_');
                        return LobbyWrapUpApiActions.isVisitorArrivedSuccess();
                    }),
                    catchError(error => {
                        this.toastService.showSuccess('_Lobby_WrapUP_Visitor_Status_Update_Error_Text_');
                        return of(LobbyWrapUpApiActions.isVisitorArrivedFailure({ error }));
                    })
                )
            )
        );
    });
}
